module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-also-by element-with-heading",
    attrs: {
      "id": "also-by"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "also-by-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Also by Luke Delaney")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "also-by-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("The Killing Boys")])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-563"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/break-rule-gradient-screen.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://ads.harpercollins.com/bobauk?isbn=9780007486076",
      "target": "_blank"
    }
  }, [_vm._v("Cold Killing")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://ads.harpercollins.com/bobauk?isbn=9780007486106",
      "target": "_blank"
    }
  }, [_vm._v("The Keeper")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://ads.harpercollins.com/bobauk?isbn=9780007486137",
      "target": "_blank"
    }
  }, [_vm._v("The Toy Taker")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://ads.harpercollins.com/bobauk?isbn=9780007585700",
      "target": "_blank"
    }
  }, [_vm._v("The Jackdaw")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://ads.harpercollins.com/bobauk?isbn=9780007585786",
      "target": "_blank"
    }
  }, [_vm._v("A Killing Mind")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://ads.harpercollins.com/bobauk?isbn=9780007585748",
      "target": "_blank"
    }
  }, [_vm._v("The Rule of Fear (standalone)")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52487d87","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/also-by-luke-delaney.vue
// module id = 72
// module chunks = 0